// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifyEmailPage_container__4NeUH","icon":"VerifyEmailPage_icon__2Ff2p"};